var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "lang" },
    _vm._l(_vm.languageList, function (item, i) {
      return _c(
        "li",
        {
          key: i,
          on: {
            click: function ($event) {
              return _vm.setLang(item)
            },
          },
        },
        [
          _c("div", { staticClass: "lang-item" }, [
            _c("img", {
              staticClass: "lang-icon",
              attrs: {
                src: require(`@/assets/img/lang/${item.img}.png`),
                alt: "",
              },
            }),
            _c("span", { staticClass: "lang-text" }, [
              _vm._v(_vm._s(_vm.$ln(item.title))),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }